import qs from 'qs';

const instance = axios.create();

// axios.defaults.headers.common['x'] = "x5100";
// instance.defaults.headers.common['a'] = "a5100";

function setHeader(key, val) {
  // instance.defaults.headers.common['x3-Authentication'] = token
  instance.defaults.headers.common[key] = val;
}

// instance.interceptors.request.use( config => {
//         console.log("1111 公共库 axios => interceptors.request.use ...");
//         console.log(config);
//         return config
//     },
//     error => {
//         return Promise.reject(error)
//     }
// )

// instance.interceptors.response.use(
//     res => {
//         // console.log("2222 公共库 axios => interceptors.response.use ...");
//         // console.log(res);

//         /*if (res.data && res.data.code === 401) {
//             vant.Notify({ type: "danger", message: res.data.msg ? res.data.msg : '未登录或登录超时' });
//             location.href=`${location.origin}/app/simple${location.search}#/login`;
//         }*/
//         return res.data
//     },
//     err => {
//         if (err && err.response) {
//             switch (err.response.status) {
//                 case 400:
//                     err.message = '请求错误'
//                     break
//                 case 401:
//                     err.message = '授权失败，请检查token'
//                     break
//                 case 403:
//                     err.message = '拒绝访问'
//                     break
//                 case 404:
//                     err.message = `请求${err.response.config.url
//             .split('/')
//             .pop()
//             .replace(/\.html/, '')}接口出错`
//                     break
//                 case 408:
//                     err.message = '请求超时'
//                     break
//                 case 500:
//                     err.message = '服务器内部错误'
//                     break
//                 case 501:
//                     err.message = '服务未实现'
//                     break
//                 case 502:
//                     err.message = '网关错误'
//                     break
//                 case 503:
//                     err.message = '服务不可用'
//                     break
//                 case 504:
//                     err.message = '网关超时'
//                     break
//                 case 505:
//                     err.message = 'HTTP版本不受支持'
//                     break
//                 default:
//             }
//         }
//         vant.Toast.clear();
//         vant.Notify({ type: "danger", message: err.message ? err.message : '接口请求错误' });
//         return Promise.reject(err)
//     }
// )

function ajax(opts) {
  let /* url = opts.url, */
    params = {
      _t_: new Date().getTime(),
      ...opts.params,
    },
    type = opts.method;

  let cancel,
    config = {
      baseURL: opts.baseURL,
      url: opts.url,
      method: type || 'post',
      cancelToken: new axios.CancelToken(c => (cancel = c)),
    };
  if (opts.headers) {
    config.headers = {
      ...opts.headers      
    }
  }

  if (type === 'get') {
    config.params = params;
  } else if (type === 'put' || type === 'patch' || type === 'delete') {
    config.data = params;
  } else {
    // config.data = type ? {} : params
    config.data = params;
  }
  let xhr = instance(config);
  xhr.cancel = cancel;

  return xhr;
}

// 判断请求是否被取消
// 传入axios请求的响应，用于判断该请求是否是被取消了
function isCancel(response) {
  return axios.isCancel(response);
}

export default {
  setHeader,
  instance,
  ajax,
  isCancel,
};
